import { IContextMenuItem } from '../../interfaces/icontext-menu-item.interface';
import { StructureComponent } from '../../../views/site/structure/structure.component';
import { StructureItemContextMenuItemBase } from './structure-context-menu-base';
import {
    NewFolderContextMenuData, NewFormInstanceContextMenuData, ShowTreeContextMenuData, HideTreeContextMenuData
} from './page-menu-classes';
import { PasteItemContextMenuData } from './item-menu-classes';
import { ClipboardService } from '../../services/clipboard.service';
import { FolderService } from '../../services/folder.service';

// Menu Data for the Context Menu opened when right-clicking in the space below the list of Folders/Forms
export class MainPanelContextMenuData {
    // Properties.
    private contextMenuData: IContextMenuItem[];

    public get MenuData(): IContextMenuItem[] {
        return this.contextMenuData;
    }

    // Constructor.
    public constructor(private structureComponent: StructureComponent, private clipboardService: ClipboardService, private folderService: FolderService) {
        this.contextMenuData = [
            new PasteItemContextMenuData('Paste ...', this.structureComponent, this.clipboardService, this.folderService),
            new PasteItemContextMenuData('Paste Reference ...', this.structureComponent, this.clipboardService, this.folderService)
        ];
    }
}
